import useJuries from '@hooks/models/useJuries'
import React, { useCallback, useMemo } from 'react'
import JuryForm from '../components/Form'

export default function useSalonJuriesForm(salon: Admin.Models.Salon) {
    const { options: juries } = useJuries()
    
    const sections = useMemo(() => {
        return salon.state?.sections.map(section => ({ label: section.name, value: `${section.id}` }))
    }, [salon.state])

    return useCallback((props: Modules.Resource.Form<Admin.Resources.Jury>) => <JuryForm {...props} juries={juries} sections={sections} />, [juries])
}